module.exports = __webpack_public_path__ + "media/images/youtube-209db441a3de3f7a2e6a6b6b8cb5d8b4.svg";